<script>
    import {mapState, mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapState({
                language: state => state.main.language,
                residence_city: state => state.main.currentUser.residence_city,
                charge_type: state => state.main.currentUser.charge_type,
                viewed_success_page: state => state.main.currentUser.viewed_success_page,
                isSecondEnter: state => state.main.isSecondEnter,
                flightIsFinish: state => state.flight.isFinish
            }),
            ...mapGetters('main', {
                not_finish_information: 'not_finish_information'
            }),
            ...mapGetters('activity', {
                not_finish_activity: 'not_finish_activity'
            }),
            ...mapGetters('hotel', {
                not_finish_hotel: 'not_finish_hotel'
            }),
            ...mapGetters('document', {
                not_finish_document: 'not_finish_document'
            }),
            allFinish: function() {
                if (this.residence_city === 1) {
                    // 常驻地-上海：基本信息完成 + 活动选择完成
                    return !this.not_finish_information && !this.not_finish_activity;
                } else {
                    if (this.charge_type === 1) {
                        // 公费：基本信息完成 + 活动选择完成 + 机票信息完成 + 酒店信息完成
                        return !this.not_finish_information
                            && !this.not_finish_activity
                            && this.flightIsFinish
                            && !this.not_finish_hotel;
                    } else {
                        // 自费：基本信息完成 + 活动选择完成 + 酒店信息完成
                        return !this.not_finish_information
                            && !this.not_finish_activity
                            && !this.not_finish_hotel;
                    }
                }
            }
        },
        methods: {
            nextPage() {
                // 首先判断当前状态是否都已填写完成
                if (this.allFinish) {
                    if (!this.viewed_success_page) {
                        // 没看过成功页，去注册成功页
                        this.handleJumpTarget('regSuccess');
                    } else {
                        // 看过成功页，去汇总页
                        this.handleJumpTarget('summary');
                    }
                    return;
                }
                // 再次进入，统统去汇总页
                if(this.isSecondEnter) {
                    this.handleJumpTarget('summary');
                    return;
                }
                switch(this.$route.name) {
                    case 'information' :
                        this.informationJump();
                        break;
                    case 'en_information' :
                        this.informationJump();
                        break;

                    case 'activity' :
                        this.activityJump();
                        break;
                    case 'en_activity' :
                        this.activityJump();
                        break;

                    case 'flight' :
                        this.flightJump();
                        break;
                    case 'en_flight' :
                        this.flightJump();
                        break;

                    case 'hotel' :
                        this.hotelJump();
                        break;
                    case 'en_hotel' :
                        this.hotelJump();
                        break;
                    default:
                        return null;
                }
            },
            // 基本信息跳页
            informationJump() {
                // -> 活动安排
                this.handleJumpTarget('activity');
            },
            // 活动安排跳页
            activityJump() {
                if (this.residence_city === 1) {
                    // 常驻地-上海 -> 注册成功
                    // 这个case在nextPage已经被劫持了
                } else {
                    // 常驻地-非上海
                    if (this.charge_type === 1) {
                        // 公费 → 机票信息
                        this.handleJumpTarget('flight');
                    } else {
                        // 自费 → 酒店信息
                        this.handleJumpTarget('hotel');
                    }
                }
            },
            // 机票跳页
            flightJump() {
                // -> 酒店信息
                this.handleJumpTarget('hotel');
            },
            // 酒店跳页
            hotelJump() {
                // -> 汇总页
                this.handleJumpTarget('summary');
            },
            // 处理中英文跳页
            handleJumpTarget(targetModule) {
                if (this.language === 'zh') {
                    this.$router.push(`/${targetModule}`);
                } else {
                    this.$router.push(`/en/${targetModule}`);
                }
            }
        }
    }
</script>
